import { sum } from "lodash";

import { HIDE_DECIMAL } from "@/hooks/useConfig";
import { FormatCurrencyFunction } from "@/hooks/useConfig/types";
import { isDefined } from "@/Utils/array-utils";

import { HelperText } from "../types";
import { Constraint } from "@/pages/scenario-builder/v3/pages/scenario-form/types";
import { SpendConstraints } from "../../../api/v2/getSpendConstraints";
import { filterFromSpendConstraints } from "../../scenario-form/utils/formValidationRules";
import { sumBy } from "lodash";

interface HistoricalSpends {
  nodes: Map<string, Record<string, { max: number }>>;
}

export const ALL_CHANNELS_OPTION = {
  label: "All Channels",
  value: "all",
};

export const getHelperText = (
  bcpKey: string,
  constraint: Constraint,
  historicalSpends: HistoricalSpends,
  spendConstraintsDTO: SpendConstraints | undefined,
  formatCurrency: FormatCurrencyFunction,
  isConstraintsFromApiEnabled: boolean
): HelperText => {
  if (!constraint.channel) {
    return { channel: undefined, minValue: undefined, maxValue: undefined };
  }

  if (isConstraintsFromApiEnabled) {
    const constraints = filterFromSpendConstraints(
      {
        brand: constraint.brand,
        category: constraint.category,
        product: constraint.product,
        channel: constraint.channel,
        geography: constraint.geography ?? null,
      },
      spendConstraintsDTO
    );

    if (constraints?.length === 0 || !constraints) {
      return { channel: undefined, minValue: undefined, maxValue: undefined };
    }

    const maxSpend = sumBy(constraints, "maxSpend") ?? 0;

    return {
      channel: undefined,
      minValue: `Min: ${formatCurrency(0, HIDE_DECIMAL)}`,
      maxValue: `Max: ${formatCurrency(maxSpend, HIDE_DECIMAL)}`,
    };
  }

  if (!bcpKey) {
    return { channel: undefined, minValue: undefined, maxValue: undefined };
  }

  const nodeHistoricalSpend = historicalSpends.nodes.get(bcpKey);
  if (!nodeHistoricalSpend) {
    return { channel: undefined, minValue: undefined, maxValue: undefined };
  }

  const maxSpend =
    constraint.channel === ALL_CHANNELS_OPTION.value
      ? sum(Object.values(nodeHistoricalSpend).map((channelSpend) => channelSpend.max))
      : nodeHistoricalSpend[constraint.channel]?.max;

  const helperText = isDefined(maxSpend) ? `Max: ${formatCurrency(maxSpend, HIDE_DECIMAL)}` : null;

  return {
    channel: undefined,
    minValue: `Min: ${formatCurrency(0, HIDE_DECIMAL)}`,
    maxValue: helperText || undefined,
  };
};
